import { SiteTariffToSave } from 'clipsal-cortex-types/src/api';
import { PaginatedResponseV2 } from 'clipsal-cortex-types/src/common/types';

import tariffs from '../stubs/tariffs.json';

export const TARIFFS_ROUTE_MAP = {
  '/v2/sites/1/tariffs': tariffs as PaginatedResponseV2<SiteTariffToSave>,
};
